import axios from "axios";

const sap = axios.create({
  baseURL: "https://proxysap.tutilabs.com.br/",
});

const api = axios.create({
  baseURL: "https://apirrimjpa.tutilabs.com.br",
  // baseURL: "http://localhost:3333",
});

const apiImagem = axios.create({
  baseURL: "https://apirrimjpa.tutilabs.com.br",
  // baseURL: "http://localhost:3333",
  // Imagem - Timeput a 4 minutos
  timeout: 60 * 10 * 1000,
});


api.interceptors.request.use((config) => {
  let token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("auth._token.local="))
    .split("%20")[1];

  if (!token) {
    //window.location.replace("https://rrimpb.tutilabs.com.br")
    // window.location.replace("http://185.209.179.253:7800")
    return;
  }

  config.headers.Authorization = `Token ${token}`;

  return config;
});

export { api, apiImagem, sap };
